
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const galleryData = [
  {
    id: 13,
    description: 'CRC 2025',
    images: [
      require("../../assets/gallery/CRC_2025.jpeg"),
      require("../../assets/gallery/CRC_2025_2.jpeg"),
     

    ]
  },
    {
    id: 12,
    description: 'International Society for Heart Research - Indian Chapter_2025',
    images: [
      require("../../assets/gallery/ISHR_2025_1.jpg"),
      require("../../assets/gallery/ISHR_2025_2.jpg"),
      require("../../assets/gallery/ISHR_2025_3.jpg"),
      require("../../assets/gallery/ISHR_2025_4.jpg"),
      require("../../assets/gallery/ISHR_2025_5.jpg"),

    ]
  },
    {
    id: 11,
    description: 'ML4Science Conference, Shillong_2025',
    images: [
      require("../../assets/gallery/ML4science_2025_1.jpg"),
      require("../../assets/gallery/ML4science_2025_2.jpg"),
      require("../../assets/gallery/ML4science_2025_3.jpg"),
      require("../../assets/gallery/ML4science_2025_4.jpg"),
    ]
  },
  {
    id: 10,
    description: 'Franco-India discussions November 2024',
    images: [
      require("../../assets/gallery/franco_india24_1.jpg"),
      require("../../assets/gallery/franco_india24_2.jpg"),
      require("../../assets/gallery/franco_india24_3.jpg"),
      require("../../assets/gallery/franco_india24_4.jpg"),
      require("../../assets/gallery/franco_india24_5.jpg"),
      require("../../assets/gallery/franco_india24_6.jpg"),
      require("../../assets/gallery/franco_india24_7.jpg"),
    ]
  },
  {
    id: 1,
    description: 'Franco-India discussions November 2023',
    images: [
      require("../../assets/gallery/Franco-IndiadiscussionsNovember2023.jpeg"),
    ]
  },
  {
    id: 2,
    description: 'Raman Charpak Fellowship, Faculty of Medicine, Nice,France, 2024',
    images: [
      require("../../assets/gallery/RamanCharpakFellowship1.jpeg"),
      require("../../assets/gallery/RamanCharpakFellowship2.jpeg")
    ]
  },
  {
    id: 3,
    description: 'Advances in Cardiovascular Medical Research, Chandigarh, February 2023',
    images: [
      require("../../assets/gallery/AdvancesinCardiovascular1.jpeg"),
      require("../../assets/gallery/AdvancesinCardiovascular2.jpeg")
    ]
  },
  {
    id: 4,
    description: 'Cardiovascular Research Convergence, Oral presentation October 2023',
    images: [
      require("../../assets/gallery/CardiovascularResearch.jpeg"),
      require("../../assets/gallery/Cardiovascular1.jpeg"),
      require("../../assets/gallery/Cardiovascular2.jpeg")
    ]
  },
  {
    id: 5,
    description: 'European atherosclerosis society meeting, Lyon, France 2024',
    images: [
      require("../../assets/gallery/Europeanatherosclerosis1.jpeg"),
      require("../../assets/gallery/Europeanatherosclerosis2.jpeg")

    ]
  },
  {
    id: 6,
    description: '1st Asian-Pacific Celiac Disease Symposium 2024',
    images: [
      require("../../assets/gallery/AsianPacificCeliacDisease.jpeg"),
      require("../../assets/gallery/AsianPacificCeliacDisease2.jpeg")
    ]
  },
  {
    id: 7,
    description: 'UPES, Dehradun, Uttrakhand, India',
    images: [
      require("../../assets/gallery/UPESDehradun.jpeg")
    ]
  },
  {
    id: 7,
    description: 'JIIT,Noida',
    images: [
      require("../../assets/gallery/JIIT,Noida.jpeg"),
    ]
  },
  {
    id: 8,
    description: 'EMBO workshop: Computational Structural Biology, Heidelberg,  Germany',
    images: [
      require("../../assets/gallery/EMBOWorkshop1.jpeg"),
      require("../../assets/gallery/EMBOWorkshop2.jpeg")
    ]
  },
  {
    id: 9,
    description: 'Team outings and Fun',
    images: [
      require("../../assets/teamOuting/diwali_2025.jpg"),
      require("../../assets/teamOuting/durga_puja_2025.jpg"),
      require("../../assets/teamOuting/outing1.jpeg"),
      require("../../assets/teamOuting/outing2.jpeg"),
      require("../../assets/teamOuting/outing3.jpeg"),
      require("../../assets/teamOuting/outing4.jpeg"),
      require("../../assets/teamOuting/outing5.jpeg"),
      require("../../assets/teamOuting/outing6.jpeg")
    ] 
  }
];

const GalleryPage = () => {
  return (
    <div className="container mx-auto py-12 px-4">
      <h1 className="text-5xl font-bold text-designColor text-center mb-8">Photo Gallery</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {galleryData.map(image => (
          <div key={image.id} className="bg-white shadow-lg rounded-lg overflow-hidden">
            <Carousel showArrows={true} autoPlay={true} infiniteLoop={true} showThumbs={false}>
              {image.images.map((img, index) => (
                <div key={index}>
                  <img src={img} alt={`Image ${image.id}-${index}`} className="w-full h-64 object-contain"/>
                </div>
              ))}
            </Carousel>
            {image.description && (
              <div className="p-6">
                <p className="text-gray-700 mb-4 text-center">{image.description}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryPage;
 
